import {  Component, Input, OnDestroy, OnInit} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Location, BlockoutSection } from '@finder/features/calendars/calendars.interface';
import { CalendarsService } from '@finder/features/calendars/services/calendar.service';
import { DateRange } from '@finder/features/calendars/calendars.interface';

@Component({
    selector: 'finder-park-row',
    templateUrl: './park-row.component.html',
    styleUrls: ['./park-row.component.scss']
})
export class ParkRowComponent implements OnInit, OnDestroy {

    @Input() location: Location;
    @Input() labels: any;

    loading = false;
    blockouts: BlockoutSection;
    sections: Array<any>;
    dateRange: DateRange;
    showLinks: boolean;
    closedForRefurbishmentLink: string;
    permanentSchedule: any;

    private destroy$ = new Subject<void>();

    constructor(
        private calendarService: CalendarsService,
    ) { }

    ngOnInit() {
        this.setSections();
        this.setBlockouts();
        this.dateRange = this.calendarService.dateRange;
        this.showLinks = this.calendarService.allowLinksOnPage();
        this.closedForRefurbishmentLink =
            `${this.calendarService.getCalendarsDefaultPath()}${this.location.closedForRefurbishmentLink?.href}`;
        this.permanentSchedule = this?.location?.permanentSchedule;

        this.calendarService.getLoadingState()
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => this.loading = state);

        this.calendarService.watchLocations()
            .pipe(takeUntil(this.destroy$))
            .subscribe(locations => {
                this.dateRange = this.calendarService.dateRange;
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setSections() {
        const events = this.location.events ?? {};
        this.sections = Object.keys(events).map((type) => {
            const eventGroup = events[type];
            const data = eventGroup.data ?? [];
            const permanentActivity = eventGroup?.permanentActivity ?? void 0;

            return {
                id: `${this.location.urlFriendlyId}--${type}`,
                type,
                data,
                permanentActivity,
                labels: {
                    sectionTitle: eventGroup.title
                }
            };
        });

    }

    setBlockouts() {
        const blockouts = this.location.blockouts;
        if (!blockouts) {
            return;
        }

        this.blockouts = {
            id: `${this.location.urlFriendlyId}--blockouts`,
            data: blockouts,
            labels: {
                sectionTitle: this.labels.blockouts
            }
        };
    }
}
